import applyStyles from '@root/tabulator/RowFormatters/_applyStyles'

export default function (row, cell, params = {}) {
  function shouldApply({ test = '' }) {
    const data = cell.getValue();
    if (test.startsWith('/')) {
      const withoutDelimiters = test.substring(1, test.length - 1);

      return new RegExp(withoutDelimiters).test(data);
    }

    return test === data;
  }

  applyStyles(shouldApply, row.getElement(), cell.getElement(), params);
}